// Корзина заявок для оплаты нескольких сразу.
// Храним не только id, но и музей/дату — чтобы показать нормальный список в шапке.
// Сумму клиент вводит вручную (цен на заявку пока нет); на бэкенд номера уходят
// через запятую — один платёж, несколько заказов.
export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems: state => state.items,
    getCount: state => state.items.length,
    getIds: state => state.items.map(item => item.id),
    isSelected: state => id => state.items.some(item => item.id === id),
  },
  mutations: {
    toggle(state, item) {
      const index = state.items.findIndex(existing => existing.id === item.id)
      if (index === -1) {
        state.items.push(item)
      } else {
        state.items.splice(index, 1)
      }
    },
    remove(state, id) {
      const index = state.items.findIndex(item => item.id === id)
      if (index !== -1) {
        state.items.splice(index, 1)
      }
    },
    clear(state) {
      state.items = []
    },
  },
}
